var map = {
	"./after_party.png": 1767,
	"./after_party@2x.png": 1768,
	"./brunch.png": 1769,
	"./brunch@2x.png": 1770,
	"./camera.svg": 890,
	"./ceremony.png": 1771,
	"./ceremony@2x.png": 1772,
	"./check.svg": 675,
	"./checklist-white-bg-trimmed.svg": 891,
	"./checklist-white-bg.svg": 1773,
	"./checklist.svg": 1774,
	"./chevron-white-thick-left.png": 1775,
	"./chevron-white-thick-right.png": 1776,
	"./chevron-white-thick.png": 1777,
	"./confetti.svg": 892,
	"./dashboard.svg": 1778,
	"./desktop_events.svg": 1779,
	"./download.svg": 1780,
	"./dropdown-focus.svg": 1741,
	"./dropdown.svg": 1740,
	"./envelope.svg": 1781,
	"./envelope_gray.svg": 1782,
	"./events.svg": 1783,
	"./faq-checklist.png": 1784,
	"./faq-checklist.svg": 1785,
	"./faq-guestlist.png": 1786,
	"./faq-guestlist.svg": 1787,
	"./faq-registry.png": 1788,
	"./faq-registry.svg": 1789,
	"./faq-website.png": 1790,
	"./faq-website.svg": 1791,
	"./giftPile.svg": 893,
	"./guest_list-white-bg.svg": 1792,
	"./guest_list.svg": 894,
	"./guestlist-white-bg-trimmed.svg": 1793,
	"./help.svg": 1794,
	"./icon-chrome.png": 1795,
	"./icon-chrome.svg": 463,
	"./icon-invites.png": 1796,
	"./icon-invites.svg": 1797,
	"./icon-website.svg": 1798,
	"./iconX.svg": 620,
	"./icon_empty.svg": 895,
	"./menu.svg": 1799,
	"./np_hidden.png": 1800,
	"./other.png": 1801,
	"./other@2x.png": 1802,
	"./profile-photo.png": 1272,
	"./profile-photo@2x.png": 1803,
	"./reception.png": 1804,
	"./reception@2x.png": 1805,
	"./redPresent.svg": 1806,
	"./registry-white-bg-trimmed.svg": 896,
	"./registry-white-bg.svg": 1807,
	"./registry.svg": 1808,
	"./rehearsal_dinner.png": 1809,
	"./rehearsal_dinner@2x.png": 1810,
	"./remove.svg": 478,
	"./silhouette.png": 1811,
	"./trashbin.png": 1812,
	"./trashcan.svg": 1813,
	"./website-white-bg-trimmed.svg": 897,
	"./website-white-bg.svg": 1814,
	"./website.svg": 1815,
	"./wedding.png": 1816,
	"./wedding@2x.png": 1817,
	"./welcome_event.png": 1818,
	"./welcome_event@2x.png": 1819,
	"./x-circle-dark.svg": 1820,
	"./x-circle-light.svg": 1821
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 852
// module chunks = 51